import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=2ead64ee&"
import script from "./create-order.vue?vue&type=script&lang=ts&"
export * from "./create-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports